import { defineComponent as _defineComponent } from 'vue'
import LegCardShell from './LegCardShell.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'RegularLegCard',
  props: {
    fromName: null,
    toName: null,
    metaLine: null,
    checked: { type: Boolean },
    disabled: { type: Boolean },
    disabledHint: null
  },
  emits: ["change"],
  setup(__props: any) {





return { __sfc: true,LegCardShell }
}

})